import { render, staticRenderFns } from "./address-add-dialog.vue?vue&type=template&id=718a459c&scoped=true"
import script from "./address-add-dialog.vue?vue&type=script&lang=js"
export * from "./address-add-dialog.vue?vue&type=script&lang=js"
import style0 from "./address-add-dialog.vue?vue&type=style&index=0&id=718a459c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718a459c",
  null
  
)

export default component.exports